import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { Helmet } from "react-helmet";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import TodayContainer from "~/Containers/TodayContainer";
import PreviousContainer from "~/Containers/PreviousContainer";
import ThisDayContainer from "~/Containers/ThisDayContainer";
import Tile from "~/Components/Tile";
import TodayEmpty from "~/Components/TodayEmpty";
import Section from "~/Components/Section";
import FeaturedOtdPost from "~/Components/FeaturedOtdPost";
import Spinner from "react-bootstrap/Spinner";
import WidePageSection from "~/Components/Global/WidePageSection";

import "./HomePage.less";

class HomePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      refresh: false,
    };
  }
  checkRecent = () => {
    console.log("error checkRecent");
    this.setState({ refresh: true });
  };

  render() {
    const { refresh } = this.state;

    if (refresh) {
      this.setState({ refresh: false });
      return <Redirect to={`/`} />;
    }

    return (
      <div className="home-page-component">
        <Helmet>
          <title>____ of the Day | Dream Chimney</title>
          <link rel="canonical" href={`https://www.dreamchimney.com/oftheday/`} />
        </Helmet>
        <div className="homePageWrapper">
          <TodayContainer
            componentType={Tile}
            render={({ posts, loading }) => {
              if (loading) {
                return (
                  <div className="container-loading">
                    <Spinner animation="border" size="sm" /> Loading...
                  </div>
                );
              }
              if (!posts.length) {
                return <TodayEmpty />;
              }
              return (
                <WidePageSection>
                  <Row>
                    {posts.map((item) => (
                      <Col xs={12} key={item.id}>
                        <FeaturedOtdPost otd={item} />
                      </Col>
                    ))}
                  </Row>
                </WidePageSection>
              );
            }}
          />
          <div className="thisDayDivider">
            <span />
            <em>Recent Posts</em>
            <span />
          </div>
          <Section title={`Here's what you missed out on a few days ago...`}>
            <PreviousContainer
              count={6}
              render={({ items, loadMore }) => (
                <div>
                  <Row noGutters className="minimalGutter">
                    {items &&
                      items.map((item) => (
                        <Col xl={4} lg={6} xs={12} key={item.id}>
                          <Tile archive otd={item} />
                        </Col>
                      ))}
                  </Row>
                </div>
              )}
            />
          </Section>
          <ThisDayContainer
            render={({ posts, loading, failure }) => {
              if (loading || failure || !posts.length) {
                return null;
              }
              return (
                <div className="thisDayHistoryWrap">
                  <div className="thisDayDivider">
                    <span />
                    <em>On This Date</em>
                    <span />
                  </div>
                  <Section
                    className="thisDayHistory"
                    title={`This day in history (${new Date().toLocaleDateString("en-US", { month: "long", day: "numeric" })})`}
                  >
                    <Row noGutters className="minimalGutter">
                      {posts.map((item) => (
                        <Col xl={4} lg={6} xs={12} key={item.id}>
                          <Tile archive showDate otd={item} />
                        </Col>
                      ))}
                    </Row>
                  </Section>
                </div>
              );
            }}
          />
        </div>
      </div>
    );
  }
}

export default HomePage;
